<template>
  <div
    class="success-window bg-white d-flex align-items-center justify-content-center"
    v-if="control"
  >
    <!-- Retorno da mensagem de sucesso -->
    <div class="text-center">
      <lottie :options="defaultOptions" :height="240" :width="240" :animCreated="play" />

      <h4 class="display-4 text-dark">Deu certo!</h4>
      <p class="text-secondary" v-html="msg" />
    </div>
  </div>
</template>

<script>
import Lottie from "vue-lottie/src/lottie.vue";
import * as animationData from "@/assets/animations/success.json";
export default {
  data: () => ({
    defaultOptions: {
      animationData: animationData.default,
      renderer: "svg",
      loop: false,
      speed: 10
    },
    animationSpeed: 0.8
  }),
  props: {
    msg: {
      type: String,
      default: "Mensagem enviada com sucesso."
    },
    control: {
      type: Boolean,
      default: false
    }
  },
  components: {
    lottie: Lottie
  },
  methods: {
    play: () => {
      this.anim.play();
    }
  }
};
</script>

<style scoped>
.success-window {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}
</style>

<!-- Google Tag Manager (noscript) -->
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P5F2JSN"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->
